<template>
  <div class="">
        <!-- 导航 -->
        <nav class="nav container">
            <div class="home_nav flex container">
                <div class="nav_logo">
                    <img src="static/img/zey_logo.png" alt="">
                </div>
                <ul class="nav_ul flex">
                    <li v-for="(item,idx) in navData" :class="{nav_active:navIdx == idx}">
                        <router-link :to="item.path">{{item.title}}</router-link>
                    </li>
                </ul>
            </div>
        </nav>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
    // 导航栏数据
      navData:[
          {title:"首页",path:"/home"},
          {title:"关于中尔",path:"/about"},
          {title:"产品介绍",path:"/products"},
          {title:"解决方案",path:"/solution"},
          {title:"企业讯息",path:"/info"},
          {title:"资源下载",path:"/resource"},
          {title:"招贤纳士",path:"/recruit"},
          {title:"联系我们",path:"/contact"},
          {title:"登录系统",path:""},
          {title:"新用户注册",path:""},
          // {title:"联系我们",path:"/contact"}
      ],
    //   navIdx:0,
    }
  },
  components:{},
  computed:{
      navIdx:function(){
            return this.getPath();
      }
  },
  methods:{
    //   navHandle(idx,path){
    //     //   this.navIdx = idx;
    //       this.$router.push(path);
    //   },
      getPath(){
            var path ="/" + this.$route.fullPath.split('/')[1];
            for(var i=0; i<this.navData.length; i++){
                if(this.navData[i].path == path){
                    return i;
                }
            }

      }
  },
  mounted:function(){},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    // 导航
    .home_nav{
        @navHig:78px;
        // background:pink;
        height:@navHig;
        position:absolute;
        top:0;
        z-index:100;

        & .nav_logo{
            width:120px;
            padding-top:10px;
            & >img{
                width:100%;
                height:auto;
            }
        }

        & .nav_ul{
            @aHig:46px;
            & >li{
                padding-top:@navHig/4;

                & >a{
                    display:inline-block;
                    text-align:center;
                    height:@aHig;
                    line-height:@aHig;
                    width:120px;
                    font-size:18px;
                    color:#fff;
                }
            }

            & .nav_active>a{
                border:1px solid #fff;
                border-radius:@aHig/2;
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue